<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <app-list-header [title]="'Application Role Usecase List'" icon="bx bx-shield-alt-2" [$parent]="getSelf()">
            </app-list-header>
        </div>
        <div class="col-md-12 mt-3">

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12">
                            <a class="btn btn-outline-secondary btn-sm radius-30 " data-bs-toggle="modal"
                                data-bs-target="#editModal" title="Add">Add</a>

                            <!-- table form -->
                            <div class="table-responsive mb-3">

                                <table id="dataTableId" class="table">
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Application</th>
                                            <th>Role</th>
                                            <th>Type</th>
                                            <th>Usecase/form</th>
                                            <th>Create</th>
                                            <th>Update</th>
                                            <th>Read</th>
                                            <th>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let e of form['list']; let i = index">
                                            <td>{{i+1}}</td>
                                            <td>
                                                {{e["applicationName"]}}
                                            </td>

                                            <td>
                                                {{e["applicationRoleName"]}}
                                            </td>

                                            <td>
                                                {{e["type"]}}
                                            </td>

                                            <td>
                                                {{e["usecaseName"]}}
                                            </td>


                                            <td>
                                                {{e["create"]}}
                                            </td>

                                            <td>
                                                {{e["update"]}}
                                            </td>

                                            <td>
                                                {{e["read"]}}
                                            </td>

                                            <td>
                                                {{e["delete"]}}
                                            </td>

                                            <td>

                                                <div class="d-flex order-actions">

                                                    <a title="Edit" data-bs-toggle="modal" data-bs-target="#editModal"
                                                        (click)="editAppRoleUsecase(e.id)"><i
                                                            class="fa fa-edit"></i></a>

                                                    <a title="Delete" class="ms-1" (click)="delete(e.id)"><i
                                                            class="fa fa-trash"></i></a>
                                                </div>


                                            </td>
                                        </tr>
                                    </tbody>
                                </table>





                                <app-list-header [$parent]="getSelf()"></app-list-header>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Application Role Usecase </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    title="Close"></button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="mb-2">
                        <label for="application" class="form-label">Application * </label>
                        <div class="input-group mb-2">
                            <select #application [(ngModel)]="form.data['applicationId']"
                                class="form-select form-select-sm" id="applicationId" name="applicationId"
                                (change)="getApplicationRole()">
                                <option value="0">--Select--</option>
                                <option *ngFor="let c of applications" value="{{c['id']}}">{{c['name']}}</option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["applicationId"]}} </span>
                    </div>


                    <div class="mb-2">
                        <label for="applicationRole" class="form-label">Application Role *</label>
                        <div class="input-group mb-2">
                            <select #applicationRole [(ngModel)]="form.data['applicationRoleId']"
                                class="form-select form-select-sm" id="applicationRoleId" name="applicationRoleId">
                                <option value="0">--Select--</option>
                                <option *ngFor="let c of applicationsroles" value="{{c['id']}}">{{c['name']}}</option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["applicationRoleId"]}} </span>
                    </div>

                    <div class="mb-2">
                        <label for="type" class="form-label">Type *</label>
                        <div class="input-group mb-2">
                            <select [(ngModel)]="form.data['type']" class="form-select form-select-sm" id="type"
                                name="type" (change)="getUsecaseOrForm()">
                                <option *ngFor="let val of types" [value]="val">{{ val }}</option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["type"]}} </span>
                    </div>


                    <div class="mb-2" *ngIf="form.data['type'] === 'usecase'">
                        <label for="userstory" class="form-label">Usecase/form*</label>
                        <div class="input-group mb-2">
                            <select #userstory [(ngModel)]="form.data['userstoryId']" class="form-select form-select-sm"
                                id="userstoryId" name="userstoryId">
                                <option value="0">--Select--</option>
                                <option *ngFor="let c of userstorys" value="{{c['id']}}">{{c['name']}}</option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["userstoryId"]}} </span>
                    </div>

                    <div class="mb-2" *ngIf="form.data['type'] !== 'usecase'">
                        <label for="userstory" class="form-label">Usecase/form *</label>
                        <div class="input-group mb-2">
                            <select #userstory [(ngModel)]="form.data['userstoryId']" class="form-select form-select-sm"
                                id="userstoryId" name="userstoryId">
                                <option value="0">--Select--</option>
                                <option *ngFor="let c of forms" value="{{c['id']}}">{{c['title']}}</option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["userstoryId"]}} </span>
                    </div>

                    <div class="mb-2">
                        <label for="create" class="form-label">Create</label>
                        <div class="input-group mb-2">
                            <select [(ngModel)]="form.data['create']" class="form-select form-select-sm" id="create"
                                name="create">
                                <option *ngFor="let permission of permissions" [value]="permission">{{ permission }}
                                </option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["create"]}} </span>
                    </div>

                    <div class="mb-2">
                        <label for="update" class="form-label">Update</label>
                        <div class="input-group mb-2">
                            <select [(ngModel)]="form.data['update']" class="form-select form-select-sm" id="update"
                                name="update">
                                <option *ngFor="let permission of permissions" [value]="permission">{{ permission }}
                                </option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["update"]}} </span>
                    </div>

                    <div class="mb-2">
                        <label for="read" class="form-label">Read</label>
                        <div class="input-group mb-2">
                            <select [(ngModel)]="form.data['read']" class="form-select form-select-sm" id="read"
                                name="read">
                                <option *ngFor="let permission of permissions" [value]="permission">{{ permission }}
                                </option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["read"]}} </span>
                    </div>

                    <div class="mb-2">
                        <label for="delete" class="form-label">Delete</label>
                        <div class="input-group mb-2">
                            <select [(ngModel)]="form.data['delete']" class="form-select form-select-sm" id="delete"
                                name="delete">
                                <option *ngFor="let permission of permissions" [value]="permission">{{ permission }}
                                </option>
                            </select>
                        </div>
                        <span style="color:red">{{form.inputerror["delete"]}} </span>
                    </div>


                </form>
            </div>

            <div class="modal-footer">
                <button (click)="save()" type="submit" class="btn btn-success btn-sm me-2 "><i
                        class="fa fa-save"></i>Save</button>
                <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal"
                    title="Close">
                    <i class="fa fa-window-close"></i> Close
                </button>
            </div>
        </div>
    </div>
</div>